import axios from 'axios'
import config from './config'

import { setSignedIn, setSignedOut } from './actions/authenticate'
import { setUser, unsetUser } from './actions/user'

const handleSignedIn = (dispatch, response) => {
  dispatch(setUser({username: response.data.username, office: response.data.office, role: response.data.role}))
  dispatch(setSignedIn())
}

const handleSignedOut = (dispatch) => {
  dispatch(setSignedOut())
  dispatch(unsetUser())
}

export const checkIfLoggedIn = ({store, dispatch}) => {
  const dp = dispatch || store.dispatch;
  const myStorage = window.localStorage
  if (myStorage.getItem('token')) {
    axios.defaults.headers.common['authorization'] = myStorage.getItem('token')
    axios.get(`${config.apiUrl}/authenticate`)
      .then(function (response) {
        console.log(response)
        response.data.success ? handleSignedIn(dp, response.data) : handleSignedOut(dp)
      })
      .catch(function (error) {
        handleSignedOut(dp)
        logOut(dp)
      })
  } else {
    handleSignedOut(dp)
  }
}

export const logOut = (dispatch) => {
  const myStorage = window.localStorage

  delete axios.defaults.headers.common['authorization']
  myStorage.removeItem('token')
  dispatch(unsetUser())
  dispatch(setSignedOut())
}


// WEBPACK FOOTER //
// ./src/auth.js